import { IFooterLinkGroup } from "./Footer.map";

export function addAssociatedDiscountToFooterLink(groups: IFooterLinkGroup[], associatedDiscountCode: string) {
  return groups.map((group) => {
    if (group.id === "slg-1") {
      return {
        ...group,
        links: group.links.map((link) => {
          if (link.id === "slg-1-a") {
            return {
              ...link,
              to: `${link.to}?${associatedDiscountCode}`,
            };
          }
          return link;
        }),
      };
    }
    return group;
  });
}
